import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addDatosSustancia } from "../../../../../../redux/actions/resolucion";
import DatosSustanciaForm from "./DatosSustanciaForm";

const initialValues = {
    nombre: "",
    sustancia: null,
    cantidad: "",
    unidad: null,
};

const DatosSustanciaContainer = ({ handleCancelSustancia, handleSubmit: handleSubmitProp }) => {
    const dispatch = useDispatch();
    const sustancias = useSelector((state) => state.resolucion.sustancias.data);
    const sustanciasAgregadas = useSelector((state) => state.resolucion.postResolucion.sustancias);
    const sustancia = useSelector((state) => state.resolucion.abmSustancia);

    const [formModel, setFormModel] = useState(sustancia?.sustancia ? {...initialValues, ...sustancia?.sustancia} : initialValues);

    const handleSubmit = (sustanciaValues) => {
        const codigoSustanciaYDescripcion = sustancias.find((v) => v.id === sustanciaValues.sustancia)?.nombre;
        dispatch(addDatosSustancia({
            ...sustanciaValues,
            nombreAgente: codigoSustanciaYDescripcion.split(" - ")[0],
            descripcionAgente: codigoSustanciaYDescripcion.split(" - ")[1],
        }));
        handleSubmitProp(sustanciaValues);
    }

    return (
        <DatosSustanciaForm
            formModel={formModel}
            handleSubmit={handleSubmit}
            handleCancelSustancia={handleCancelSustancia}
            sustanciasAgregadas={sustanciasAgregadas}
            sustancia={sustancia}
        />
    )

}

export default DatosSustanciaContainer;